module.exports = __webpack_public_path__ + "img/grid-3.fe8f0422.svg";